export const errorCodeHandler = (response) => {
  // console.dir(response);
  if (!response.ok) {
    // refresh auth token if status is 417
    if (response.status === 417) {
      throw "PerformRefreshToken";
    } else if (response.status === 401) {
      throw "PerformUnauthorizedToken";
    } else if (response.status === 500) {
      throw "GenericError";
    } else {
      return response;
    }
  }

  return response;
};

export const errorMessageHandler = (response) => {
  if (response.errorMessage) {
    throw response.errorMessage;
  } else if (response.errorCode) {
    throw "Oops! Something went wrong!";
  } else {
    return response;
  }
};

export const errorMessageHandlerCustom = (response) => {
  // console.dir(response);
  if (response.clientErrorMessage) {
    throw response.clientErrorMessage;
  } else if (response.errorMessage) {
    throw response.errorMessage;
  } else if (response.errorCode) {
    throw "Oops! Something went wrong!";
  } else {
    return response;
  }
};

export const errorHandleNoBody = (response) => {
  if (response.status !== 200) {
    return response.json();
  } else {
    return response;
  }
};
